var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgGLabel(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "31px",
    height: "29px",
    viewBox: "0 0 31 29",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "Group Copy 3") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Search-of-a-video",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group-Copy-3",
    transform: "translate(0.500000, 0.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group-4",
    transform: "translate(0.500000, 0.000000)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M8,0 L29,0 L29,0 L29,29 L8,29 C3.581722,29 1.61501417e-15,25.418278 0,21 L0,8 C-1.42926142e-15,3.581722 3.581722,-7.65539184e-17 8,0 Z",
    id: "Rectangle",
    fill: "#CB0000"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M13.0948,6 C14.6032,6 16.0612,6.6264 17.16208,7.73376 L17.16208,7.73376 L17.16208,6.65376 C17.1618888,6.55605686 17.2005673,6.46228989 17.2695864,6.39313571 C17.3386055,6.32398152 17.4322967,6.28511981 17.53,6.28512 L17.53,6.28512 L18.97504,6.28512 C19.1786343,6.28512 19.34368,6.45016575 19.34368,6.65376 L19.34368,6.65376 L19.34368,16.8396 C19.34368,18.98592 18.72304,20.73336 17.54872,21.89328 C16.48096,22.94736 14.99416,23.5053681 13.24888,23.5053681 C12.2059644,23.507057 11.1799981,23.2415799 10.2688,22.73424 C10.1755449,22.6812457 10.1099955,22.5902627 10.0892525,22.4850265 C10.0685095,22.3797904 10.0946302,22.2707384 10.1608,22.18632 L10.1608,22.18632 L11.0248,21.08184 C11.134048,20.9408152 11.3292197,20.8994059 11.48632,20.98392 C12.0291166,21.2737634 12.6349848,21.4253541 13.25032,21.42528 C15.84592,21.42528 17.16208,19.88232 17.16208,16.8396 L17.16208,16.8396 L17.16208,16.5516 C16.0804081,17.6264104 14.6196517,18.2330548 13.0948,18.24072 C9.73049613,18.2371492 7.00396826,15.5109434 7,12.14664 C7,8.81448 9.79072,6 13.0948,6 Z M21.64624,20.83992 C21.8450625,20.83992 22.00624,21.0010975 22.00624,21.19992 L22.00624,23.14392 C22.00624,23.3427425 21.8450625,23.50392 21.64624,23.50392 L19.70224,23.50392 C19.5034175,23.50392 19.34224,23.3427425 19.34224,23.14392 L19.34224,21.19992 C19.34224,21.0010975 19.5034175,20.83992 19.70224,20.83992 L21.64624,20.83992 Z M13.04296,8.07936 C10.91464,8.07936 9.18304,9.8952 9.18304,12.14664 C9.18304,14.39808 10.87864,16.16136 13.04296,16.16136 C15.2476,16.16136 17.10952,14.31384 17.10952,12.14664 C17.10952,9.97944 15.20944,8.07936 13.04296,8.07936 Z",
    id: "Combined-Shape",
    fill: "#FFFFFF",
    fillRule: "nonzero"
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGLabel);
export default __webpack_public_path__ + "static/media/g-label.5e2883ee1b9fbe987283f714a33a3c18.svg";
export { ForwardRef as ReactComponent };